import React from "react";

import Button from "components/common/Button";

import FamilyRestroomOutlinedIcon from "@mui/icons-material/FamilyRestroomOutlined";

function NoDataScreen({ onAddDependents }) {
  return (
    <div className="flex flex-col pt-1 pb-15 pl-2">
      <p className="heading-h4-semibold">Dependents</p>
      <div className="flex flex-col items-center justify-center">
        <FamilyRestroomOutlinedIcon className="dependents-main-icon" />
        <p className="para-body-m-regular mb-1">This employee currently does not have any dependents added.</p>
        <Button variant="outlined" size="small" label="Add Dependents" onClick={onAddDependents} />
      </div>
    </div>
  );
}

export default NoDataScreen;
